module.exports = "<TextField label=\"Help text\" helpertext=\"This is the helptext\" />\n"